import { render, staticRenderFns } from "./PointCheckRecycleBinModal.vue?vue&type=template&id=e230bb94&scoped=true"
import script from "./PointCheckRecycleBinModal.vue?vue&type=script&lang=js"
export * from "./PointCheckRecycleBinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e230bb94",
  null
  
)

export default component.exports